interface HbsStrengthMeterProps {
  /** 0–1; values outside this range are clamped. */
  strength: number;
}

type Tier = { label: 'Weak' | 'Okay' | 'Good' | 'Strong'; color: 'danger' | 'warning' | 'success' };

function tierFor(strength: number): Tier {
  if (strength < 0.25) return { label: 'Weak', color: 'danger' };
  if (strength < 0.55) return { label: 'Okay', color: 'warning' };
  if (strength < 0.8) return { label: 'Good', color: 'success' };
  return { label: 'Strong', color: 'success' };
}

const COLOR_BG: Record<Tier['color'], string> = {
  danger: 'bg-hbs-danger',
  warning: 'bg-hbs-warning',
  success: 'bg-hbs-success',
};

const COLOR_TEXT: Record<Tier['color'], string> = {
  danger: 'text-hbs-danger',
  warning: 'text-hbs-warning',
  success: 'text-hbs-success',
};

export function HbsStrengthMeter({ strength }: HbsStrengthMeterProps): JSX.Element {
  const clamped = Math.max(0, Math.min(1, strength));
  const filled = Math.round(clamped * 4);
  const tier = tierFor(clamped);

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex gap-1.5">
        {[0, 1, 2, 3].map((i) => {
          const isOn = i < filled;
          return (
            <div
              key={i}
              data-segment
              data-filled={isOn || undefined}
              className={`h-[5px] flex-1 rounded-full ${isOn ? COLOR_BG[tier.color] : 'bg-hbs-surface-alt'}`}
            />
          );
        })}
      </div>
      <span className={`text-[12.5px] font-semibold ${COLOR_TEXT[tier.color]}`}>{tier.label}</span>
    </div>
  );
}
